import React, { useEffect, useState } from 'react';

const Assessment = () => {
    return <p>Assessment</p>
}

export default Assessment;